/**
 * Визуальная подпись банка в админке.
 * Коды для API/логики не меняем: ICB остаётся ICB на бэкенде.
 */
export function displayBankName(raw: string | null | undefined): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if (s.toUpperCase() === 'ICB') return 'VIETIN';
  return s.replace(/\bICB\b/g, 'VIETIN');
}
